import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, withDirectives as _withDirectives } from "vue"

import { ref, Ref, onMounted, onUnmounted, computed }    from 'vue';
/********************************
 ********** COMPONENTS **********
 *******************************/
import { Chart } from 'highcharts-vue';

/********************************
 *********** FUNCTION ***********
 *******************************/
import { getOptionsInGraphs } from '@/functions/project';

/********************************
 ********** CONSTANTES **********
 *******************************/
import CONSTGRAPHS from '@/constants/graphs';

/********************************
 ************ VUETIFY ***********
 *******************************/
import { useTheme } from 'vuetify';
import { useI18n } from 'vue-i18n';

export default /*#__PURE__*/_defineComponent({
  __name: 'MultipleCharts',
  props: {
    arrayItems: { required:true, type: Array }, arrayNames: { required:true, type: Array},
    title: { required:true, type:String }
},
  setup(__props) {

const props = __props;

const theme = useTheme();

/********************************
 ************ I18N **************
 *******************************/
const { t } = useI18n();



const finalARRAYITEMS       = ref(props.arrayItems);
const finalARRAYNAMES       = ref(props.arrayNames);
const finalObjs:Ref<any[]>         = ref([]);
const showChart = ref(false)
const zones = ref<any>(CONSTGRAPHS.ZONES[props.title])

const tooltip:any =  props.title === 'Reset' ? {
    formatter: function(){
         return t('labels.latency')+ `: <b>` +(this.y??0) + ' ms' ;
    },
    
} : { valueDecimals: 2 };

const yAxisTitle            = ref(CONSTGRAPHS.YAXISLABEL[props.title] || '');
const colorText             = computed(() => theme.global.current.value.colors.colorText)

const finalYAxis = ref({
    
    title: {
        text: yAxisTitle,
        style:{ color: colorText }
    },
    style: { color: colorText }
})

const finalTitle = computed(() => props.title)


const seriesValue = ref(finalObjs.value)
/**
 * getOptionsInGraphs(tipo, serie, titulo, subtitulo, ocultar leyenda, altura, tooltip, yaxis)
 */
const finalOptions:any = ref(getOptionsInGraphs('line',seriesValue.value,props.title === 'Reset' ? 'Latencia' : finalTitle.value ,'',true,550,tooltip, finalYAxis));

const getAllData = async() => {
    for(let i=0; i<finalARRAYITEMS.value.length; i++ ){
        finalObjs.value.push(
            {
                name: finalARRAYNAMES.value[i],
                data: finalARRAYITEMS.value[i],
                zones: zones.value,
            },
        )
    }
}


const chartRef = ref<any>();
const duplicateChart = ref();

onMounted(async () => {
    await getAllData();
    showChart.value = true;
    setTimeout(() => {
        duplicateChart.value = chartRef.value;
    }, 500);
})

onUnmounted(() => {
    if(duplicateChart.value){
        duplicateChart.value.chart.destroy();
    }
});



const isactive = ref(false);

const onClickOutside = () => {
    isactive.value = false;
}

const activeClick = () =>{
    isactive.value = true;
}


return (_ctx: any,_cache: any) => {
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (showChart.value)
    ? _withDirectives((_openBlock(), _createBlock(_component_v_sheet, {
        key: 0,
        color: "transparent",
        class: "containerAreaSheet",
        onClick: activeClick
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Chart), {
            class: _normalizeClass([isactive.value ? 'borderActive' : '', "hc"]),
            constructorType: 'stockChart',
            options: finalOptions.value,
            ref: "chart"
          }, null, 8, ["class", "options"]),
          (!isactive.value)
            ? (_openBlock(), _createBlock(_component_v_sheet, {
                key: 0,
                class: "areaChartSheet"
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })), [
        [_directive_click_outside, {handler: onClickOutside}]
      ])
    : _createCommentVNode("", true)
}
}

})